// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-0c08933e]{min-height:calc(100vh - var(--header-height) - 16px);margin:0 16px 0 0;margin-left:calc(var(--left-aside-width) + 16px);padding-bottom:calc(100px + env(safe-area-inset-bottom) + 100vh - var(--vh)*100);padding-top:calc(var(--header-height) + 32px + env(safe-area-inset-top, 16px));box-sizing:border-box}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
